import * as React from 'react';

import type * as api from '@gitbook/api-client';
import { ActionableContainerSkeleton, Alert } from '@gitbook/spine-react';
import { ErrorBoundary } from '@gitbook/util-debug';

import { IntegrationConfigureSpaceFlowById, IntegrationStepWrapper } from '../../../../Components';
import { useContactSupport } from '../../../../state';
import type { GitSyncInstallationStepProps } from '../types';

/**
 * Space configuration step inside a GitSync installation flow.
 */
export function ConfigurationStep(
    props: GitSyncInstallationStepProps & { integration: api.Integration }
) {
    const { integration, space, onNext } = props;
    const contactSupport = useContactSupport();

    return (
        <IntegrationStepWrapper
            title="Space configuration"
            description="Configure the sync with the Git provider for this space"
        >
            <ErrorBoundary
                fallback={
                    <Alert
                        kind="danger"
                        title="Error while loading the integration"
                        details="Something went wrong while loading the integration configuration component. This is unusual, please get in touch with our support."
                        action={{
                            label: 'Contact support',
                            onPress: () => {
                                contactSupport({
                                    message: '',
                                });
                            },
                        }}
                    />
                }
            >
                <React.Suspense fallback={<ActionableContainerSkeleton />}>
                    <IntegrationConfigureSpaceFlowById
                        integrationName={integration.name}
                        organizationId={space.organization}
                        spaceId={space.id}
                        onComplete={() => {
                            onNext(integration);
                        }}
                    />
                </React.Suspense>
            </ErrorBoundary>
        </IntegrationStepWrapper>
    );
}
